import { onMounted, onBeforeUnmount } from 'vue';
import { useNuxtApp, useRuntimeConfig } from 'nuxt/app';

export function insertFlixmedia ({ productId, eanCode, idFlixMinisite, idFlixInpage }) {
  const { $i18n } = useNuxtApp();

  let flixMediaScriptTag = null;

  onMounted(() => {
    const { public: { flixmediaDistributor } } = useRuntimeConfig();
    const isFlixIncluded = flixmediaDistributor && productId/* && this.$store.state.cookieConsent.marketing */;
    if (isFlixIncluded) {
      flixMediaScriptTag = document.createElement('script');
      flixMediaScriptTag.src = 'https://media.flixfacts.com/js/loader.js';
      flixMediaScriptTag.setAttribute('data-flix-distributor', flixmediaDistributor);
      flixMediaScriptTag.setAttribute('data-flix-language', $i18n.locale.value);
      flixMediaScriptTag.setAttribute('data-flix-brand', '');
      flixMediaScriptTag.setAttribute('data-flix-mpn', '');
      flixMediaScriptTag.setAttribute('data-flix-ean', eanCode);
      flixMediaScriptTag.setAttribute('data-flix-sku', '');
      flixMediaScriptTag.setAttribute('data-flix-button', idFlixMinisite);
      flixMediaScriptTag.setAttribute('data-flix-inpage', idFlixInpage);
      flixMediaScriptTag.setAttribute('data-flix-button-image', '');
      flixMediaScriptTag.setAttribute('data-flix-fallback-language', '');
      flixMediaScriptTag.setAttribute('data-flix-price', '');
      flixMediaScriptTag.async = true;
      document.body.appendChild(flixMediaScriptTag);
    }
  });

  onBeforeUnmount(() => {
    if (flixMediaScriptTag) {
      document.body.removeChild(flixMediaScriptTag);
    }
  });
}
